(function($, window) {
  'use strict';

  var BankStatementImportPage = function() {
    this.container = $('.client-bank-import');
    this.transactionTypes = this.container.data('transactionTypes') || [];
    this.executeUrl = this.container.data('executeUrl');
    this.csrfToken = $('meta[name="csrf-token"]').attr('content');
    this.groupedTypes = groupTransactionTypes(this.transactionTypes);
    this.categoryOrder = ['income', 'expense', 'transfer'];
    this.store = {
      transactions: [],
      extractedText: ''
    };
    this.isExecuting = false;
    exposePublicAPI(this);

    if (!this.container.length) return;

    this.elements = {
      form: $('#bank-statement-upload-form'),
      fileInput: $('#bank_statement_image'),
      startButton: $('#start-import-button'),
      resetButton: $('#reset-preview'),
      importButton: $('#execute-import-button'),
      status: $('.import-status'),
      error: $('.import-error'),
      previewBox: $('#import-preview'),
      previewSummary: $('#preview-summary'),
      previewTableBody: $('.import-preview-table tbody'),
      extractedText: $('#extracted-text-preview')
    };

    this.bindEvents();
    exposePublicAPI(this);
  };

  BankStatementImportPage.prototype.bindEvents = function() {
    var self = this;

    this.elements.form.on('submit', function(event) {
      event.preventDefault();
      self.submit();
    });

    this.elements.resetButton.on('click', function() {
      self.resetPreview();
    });

    this.elements.importButton.on('click', function() {
      self.executeImport();
    });
  };

  BankStatementImportPage.prototype.submit = function() {
    var fileInput = this.elements.fileInput[0];
    if (!fileInput.files || !fileInput.files.length) {
      this.showError('ファイルが選択されていません。');
      return;
    }

    var formData = new FormData(this.elements.form[0]);
    this.showStatus('解析を実行中です。しばらくお待ちください…');
    this.showError(null);
    this.elements.startButton.prop('disabled', true);
    this.elements.resetButton.prop('disabled', true);
    this.elements.importButton.prop('disabled', true);

    var headers = {
      Accept: 'application/json'
    };
    if (this.csrfToken) {
      headers['X-CSRF-Token'] = this.csrfToken;
    }

    var self = this;
    $.ajax({
      url: this.elements.form.attr('action'),
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      headers: headers,
      success: function(response) {
        self.onSuccess(response);
      },
      error: function(xhr) {
        self.onError(xhr);
      },
      complete: function() {
        self.elements.startButton.prop('disabled', false);
      }
    });
  };

  BankStatementImportPage.prototype.onSuccess = function(response) {
    this.hideStatus();
    this.showError(null);

    var transactions = (response.transactions || []).map(function(txn) {
      var amount = normalizeInteger(txn.amount);
      return {
        transaction_date: txn.transaction_date || '',
        amount: amount,
        note: txn.note || '',
        transaction_type_id: txn.transaction_type_id,
        category: txn.category || determineCategory(amount),
        warnings: txn.warnings || [],
        errors: txn.errors || [],
        validation_status: txn.validation_status || null,
        selected: txn.selected !== false
      };
    });

    this.store.transactions = transactions.map(this.decorateTransaction.bind(this));
    this.store.extractedText = response.extracted_text || '';
    this.renderPreview();
    this.elements.fileInput.val('');
    this.elements.resetButton.prop('disabled', false);
    this.updateImportButtonState();
  };

  BankStatementImportPage.prototype.onError = function(xhr) {
    this.hideStatus();
    var message = '解析中にエラーが発生しました。時間をおいて再度お試しください。';

    if (xhr.responseJSON && xhr.responseJSON.error) {
      message = xhr.responseJSON.error;
    } else if (xhr.status === 0) {
      message = 'サーバーとの通信に失敗しました。ネットワーク設定をご確認ください。';
    }

    this.showError(message);
  };

  BankStatementImportPage.prototype.renderPreview = function() {
    var self = this;
    var tbody = this.elements.previewTableBody;
    tbody.empty();

    this.store.transactions.forEach(function(txn, index) {
      var row = $('<tr>').attr('data-index', index);

      var checkboxCell = $('<td>');
      var checkbox = $('<input type="checkbox" class="import-row-select">')
        .attr('data-index', index)
        .prop('checked', txn.selected !== false)
        .on('change', function() {
          self.updateTransaction(index, 'selected', $(this).is(':checked'));
        });
      checkboxCell.append(checkbox);

      var dateInput = $('<input type="date" class="form-control transaction-date-input">')
        .attr('data-index', index)
        .val(txn.transaction_date)
        .on('change', function() {
          self.updateTransaction(index, 'transaction_date', $(this).val());
        });

      var amountInput = $('<input type="number" class="form-control transaction-amount-input">')
        .attr('data-index', index)
        .val(txn.amount != null ? txn.amount : '')
        .on('change', function() {
          self.updateTransaction(index, 'amount', normalizeInteger($(this).val()));
        });

      var noteInput = $('<input type="text" class="form-control transaction-note-input">')
        .attr('data-index', index)
        .val(txn.note)
        .on('change', function() {
          self.updateTransaction(index, 'note', $(this).val());
        });

      var transactionTypeSelect = buildTransactionTypeSelect(
        this.groupedTypes,
        this.categoryOrder,
        txn.category,
        index,
        txn.transaction_type_id,
        this
      );

      var statusCell = $('<td class="preview-status col-transaction-status">');
      renderStatusBadges(statusCell, txn);

      row.append(checkboxCell);
      row.append($('<td class="col-transaction-date">').append(dateInput));
      row.append($('<td class="col-transaction-amount">').append(amountInput));
      row.append($('<td class="col-transaction-note">').append(noteInput));
      row.append($('<td class="transaction-type-column">').append(transactionTypeSelect));
      row.append(statusCell);

      tbody.append(row);
    }, this);

    this.elements.previewSummary.text(this.previewSummaryText());
    this.elements.previewBox.removeClass('hidden');
    this.elements.extractedText.val(this.store.extractedText);
    this.initializeSelect2();
    this.updateImportButtonState();
  };

  BankStatementImportPage.prototype.previewSummaryText = function() {
    var total = this.store.transactions.length;
    var selected = this.store.transactions.filter(function(txn) { return txn.selected; }).length;
    return total === 0 ? '0件' : total + '件（選択中 ' + selected + '件）';
  };

  BankStatementImportPage.prototype.decorateTransaction = function(txn) {
    var decorated = $.extend({}, txn);
    if (decorated.category == null) {
      decorated.category = determineCategory(decorated.amount);
    }
    if (typeof decorated.selected === 'undefined') {
      decorated.selected = true;
    }
    return decorated;
  };

  BankStatementImportPage.prototype.updateTransaction = function(index, key, value) {
    if (!this.store.transactions[index]) return;

    this.store.transactions[index][key] = value;

    if (key === 'amount') {
      this.store.transactions[index].category = determineCategory(value);
      this.renderPreview();
      return;
    }

    if (key === 'selected') {
      this.elements.previewSummary.text(this.previewSummaryText());
    }
    this.updateImportButtonState();
  };

  BankStatementImportPage.prototype.resetPreview = function() {
    this.store.transactions = [];
    this.store.extractedText = '';
    this.elements.previewTableBody.empty();
    this.elements.previewBox.addClass('hidden');
    this.elements.previewSummary.text('0件');
    this.elements.extractedText.val('');
    this.elements.resetButton.prop('disabled', true);
    this.elements.fileInput.val('');
    this.hideStatus();
    this.showError(null);
    this.updateImportButtonState();
  };

  BankStatementImportPage.prototype.showStatus = function(message) {
    if (!message) {
      this.hideStatus();
      return;
    }
    this.elements.status.text(message).removeClass('hidden');
  };

  BankStatementImportPage.prototype.hideStatus = function() {
    this.elements.status.addClass('hidden').text('');
  };

  BankStatementImportPage.prototype.showError = function(message) {
    if (!message) {
      this.elements.error.addClass('hidden').text('');
      return;
    }
    this.elements.error.text(message).removeClass('hidden');
  };

  BankStatementImportPage.prototype.exportPayload = function() {
    var selectedTransactions = this.store.transactions
      .filter(function(txn) { return txn.selected; })
      .map(function(txn) {
        return {
          transaction_date: txn.transaction_date,
          amount: txn.amount,
          note: txn.note,
          transaction_type_id: txn.transaction_type_id,
          category: txn.category
        };
      });

    return {
      extracted_text: this.store.extractedText,
      transactions: selectedTransactions
    };
  };

  BankStatementImportPage.prototype.updateImportButtonState = function() {
    if (!this.elements.importButton.length) return;
    var hasTransactions = this.store.transactions.length > 0;
    var hasSelected = this.store.transactions.some(function(txn) { return txn.selected; });
    var disabled = !(hasTransactions && hasSelected) || this.isExecuting;
    this.elements.importButton.prop('disabled', disabled);
  };

  BankStatementImportPage.prototype.executeImport = function() {
    if (!this.executeUrl) {
      this.showError('インポート先のURLが設定されていません。管理者にお問い合わせください。');
      return;
    }

    var payload = this.exportPayload();
    if (!payload.transactions.length) {
      this.showError('インポートする取引を1件以上選択してください。');
      return;
    }

    payload.matter_id = this.elements.form.find('input[name="matter_id"]').val();
    payload.client_bank_id = this.elements.form.find('input[name="client_bank_id"]').val();

    this.showStatus('インポートを実行しています…');
    this.showError(null);
    this.isExecuting = true;
    this.updateImportButtonState();

    var headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };
    if (this.csrfToken) {
      headers['X-CSRF-Token'] = this.csrfToken;
    }

    var self = this;
    $.ajax({
      url: this.executeUrl,
      method: 'POST',
      data: JSON.stringify(payload),
      dataType: 'json',
      headers: headers,
      success: function(response) {
        self.onExecuteSuccess(response);
      },
      error: function(xhr) {
        self.onError(xhr);
      },
      complete: function() {
        self.isExecuting = false;
        self.updateImportButtonState();
      }
    });
  };

  BankStatementImportPage.prototype.onExecuteSuccess = function(response) {
    var message = response.message || 'インポートが完了しました。詳細画面に移動します。';
    this.showStatus(message);
    if (response.redirect_url) {
      window.setTimeout(function() {
        window.location.href = response.redirect_url;
      }, 1200);
    } else {
      this.elements.importButton.prop('disabled', true);
    }
  };

  BankStatementImportPage.prototype.initializeSelect2 = function() {
    var selects = this.elements.previewTableBody.find('select.transaction-type-select');
    selects.each(function() {
      var $select = $(this);
      if ($select.data('select2')) {
        $select.select2('destroy');
      }
      $select.select2({
        width: 'resolve',
        placeholder: '取引種別を選択'
      });
    });
  };

  function buildTransactionTypeSelect(groupedTypes, categoryOrder, category, index, currentId, pageInstance) {
    var select = $('<select class="form-control transaction-type-select">')
      .attr('data-index', index)
      .append($('<option>').val('').text('選択してください'))
      .on('change', function() {
        var typeId = $(this).val() ? parseInt($(this).val(), 10) : null;
        pageInstance.updateTransaction(index, 'transaction_type_id', typeId);
      });

    var options = optionsForCategory(groupedTypes, category, categoryOrder);
    options.forEach(function(item) {
      select.append(
        $('<option>').val(item.id).text(item.label)
      );
    });

    if (currentId) {
      select.val(String(currentId));
    }

    return select;
  }

  function renderStatusBadges(cell, txn) {
    cell.empty();
    (txn.errors || []).forEach(function(err) {
      cell.append($('<span class="label label-danger status-badge">').text(err));
    });
    (txn.warnings || []).forEach(function(warn) {
      cell.append($('<span class="label label-warning status-badge">').text(warn));
    });
    if ((txn.errors || []).length === 0 && (txn.warnings || []).length === 0) {
      cell.append($('<span class="text-muted">-</span>'));
    }
  }

  function groupTransactionTypes(types) {
    var labels = {
      income: '収入',
      expense: '支出',
      transfer: '振替'
    };

    return types.reduce(function(acc, type) {
      var category = type.category;
      if (!acc[category]) {
        acc[category] = {
          label: type.category_label || labels[category] || category,
          items: []
        };
      }
      acc[category].items.push({
        id: type.id,
        label: buildOptionLabel(type.label, type.code)
      });
      return acc;
    }, {});
  }

  function optionsForCategory(groupedTypes, category, categoryOrder) {
    if (category && groupedTypes[category]) {
      return groupedTypes[category].items.slice();
    }

    var ordered = [];
    (categoryOrder || []).forEach(function(cat) {
      if (groupedTypes[cat]) {
        ordered = ordered.concat(groupedTypes[cat].items);
      }
    });

    Object.keys(groupedTypes).forEach(function(cat) {
      if (!categoryOrder || categoryOrder.indexOf(cat) === -1) {
        ordered = ordered.concat(groupedTypes[cat].items);
      }
    });

    return ordered;
  }

  function normalizeInteger(value) {
    if (value === null || value === undefined || value === '') return null;
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function determineCategory(amount) {
    if (amount === null || amount === undefined) return null;
    if (amount > 0) return 'income';
    if (amount < 0) return 'expense';
    return null;
  }

  function buildOptionLabel(label, code) {
    var displayCode = code || 'custom';
    return label + '（' + displayCode + '）';
  }

  function exposePublicAPI(pageInstance) {
    window.BankStatementImport = {
      currentPayload: function() {
        return pageInstance.exportPayload();
      },
      reset: function() {
        pageInstance.resetPreview();
      }
    };
  }

  $(document).on('turbo:load', function() {
    new BankStatementImportPage();
  });
})(jQuery, window);
